import Vue from 'vue'
import Vuex from 'vuex'
import main from './modules/main.js'
import trade from './modules/trade'
import getters from './getters.js'
import createPersistedstate from 'vuex-persistedstate'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    main,
    trade
  },
  getters,
  plugins: [
    createPersistedstate({
      // 存储方式：localStorage、sessionStorage、cookies
      storage: window.sessionStorage,
      key: 'nwt_trade',
      paths: ['trade']
    })
  ]
})
window._store = store
export default store


// WEBPACK FOOTER //
// ./src/store/index.js